import { useLocation } from 'react-router';

import {
  advanceNavigationContext,
  toViewPath
} from '~/utils/navigationContext';

export default function useNavigationContextManager() {
  const { pathname, search } = useLocation();

  advanceNavigationContext(toViewPath(pathname, search));
}
